import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      number: '50,000+',
      label: 'Cars Financed',
      description: 'Happy customers driving their dream cars'
    },
    {
      number: '4.8/5',
      label: 'Customer Rating',
      description: 'Based on thousands of reviews'
    },
    {
      number: '5 Min',
      label: 'Average Approval',
      description: 'From application to pre-approval'
    },
    {
      number: '24/7',
      label: 'Customer Support',
      description: 'Always here when you need us'
    }
  ];

  return (
    <section className="py-20 bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Trusted by Thousands of Canadians
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Join the growing community of satisfied customers who found their perfect car with us
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-yellow-400 mb-2">
                {stat.number}
              </div>
              <div className="text-xl font-semibold mb-2">
                {stat.label}
              </div>
              <div className="text-blue-200 text-sm">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;

